import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Order',
    component: () => import("@/views/order.vue")
  },
  {
    path: '/loading',
    name: 'Loading',
    component: () => import("@/views/loading.vue")
  },
  {
    path: '/result',
    name: 'Result',
    component: () => import("@/views/result.vue")
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import("@/views/search.vue")
  },
  {
    path: '/error-page',
    name: 'ErrorPage',
    component: () => import("@/views/error.vue")
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
